import { cn } from '@poseidon/components/cn';
import { Time } from '@poseidon/components/StrokeIcons';

import type { SequenceStep } from '~/components/Sequence/sequenceSteps';
import { STEP_META, STEP_TILE_CLASS, STEP_TILE_COLORS, stepLabel } from '~/components/Sequence/sequenceSteps';

/**
 * A read-only visual of a sequence step — the same icon tile / wait pill as {@link SequenceGraphNode}
 * but with no controls (no remove, no editable duration). Used as the drag ghost that tracks the
 * cursor and as the "shadow" of where a node will drop. Purely presentational.
 */
export function SequenceNodePreview({ step, className }: { step: SequenceStep; className?: string }) {
  if (step.type === 'wait') {
    return (
      <div
        className={cn(
          'flex h-9 items-center gap-1.5 rounded-full border border-lynch-200 bg-white px-3 text-xs font-medium text-lynch-600 shadow-lg dark:border-slate-700 dark:bg-slate-900 dark:text-lynch-300',
          className,
        )}>
        <Time.Clock className="size-4 shrink-0 text-lynch-500 dark:text-lynch-400" />
        {stepLabel(step)}
      </div>
    );
  }
  return (
    <div className={cn(STEP_TILE_CLASS, STEP_TILE_COLORS, 'shadow-lg', className)}>{STEP_META[step.type].icon}</div>
  );
}
